import {Component} from 'vue-property-decorator'
import AppBase from '../lib/sissbase'
import Ajax from '../lib/ajax'
@Component
export class isShareAppIdShow extends AppBase {
  IsShareAppIdShow(shopid) {
    console.log('shopid=====', shopid)
    Ajax.get('/api/services/app/CodeManagementService/IsShareAppIdShow').then(res => {
      let storeyards = res.data.result
      let servicebranch = sessionStorage.getItem('servicebranch')
      console.log('servicebranch=====', servicebranch)
      if (storeyards) {
        window.wx.miniProgram.navigateTo({
          url: "/pages/share/share?branch=" + servicebranch + '&shopid=' + shopid
        })
      } else {
        window.wx.miniProgram.navigateTo({
          url: "/pages/register/register?branch=" + servicebranch
        })
      }
    })
  }
  IsShareAppIdShowV2(shopid, unique_mark) {
    console.log('shopid=====', shopid)
    console.log('unique_mark===', unique_mark)
    Ajax.get('/api/services/app/CodeManagementService/IsShareAppIdShow').then(res => {
      let storeyards = res.data.result
      let servicebranch = sessionStorage.getItem('servicebranch')
      console.log('servicebranch=====', servicebranch)
      if (storeyards) {
        window.wx.miniProgram.navigateTo({
          url: "/pages/share/share?branch=" + servicebranch + "&unique_mark=" + unique_mark + '&shopid=' + shopid
        });
      } else {
        window.wx.miniProgram.navigateTo({
          url: "/pages/register/register?branch=" + servicebranch + "&unique_mark=" + unique_mark + '&shopid=' + shopid
        })
      }
    })
  }
}